// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pc-1";
export var messageSideRight = "_pc-2";
export var subscribeToBackInStockBubbleContainer = "_pc-0";